import { React, useState } from "react";
import styled from "styled-components";
import { Row, Col } from "antd";
import HeaderNav from "../../Components/Header/Header";
import { Layout, Form, Input, Button, Checkbox } from "antd";
import {RightLayoutContainer, HaberForm, OtherPages, FeedbackBoard } from "../styledElements";
import { GlobalSet} from "../pageStyled";
import PageMenuData from "../../Components/PageMenu/pageMenu";
import logoCompany from "../../Assets/Images/haberlogo.svg";
import twitter from "../../Assets/Icons/twitter.svg";
import linkedin from "../../Assets/Icons/linkedin.svg";
import website from "../../Assets/Icons/website.svg";
import { CUSTOMER_ACCOUNT } from "../../Constants/serverAddress";
import { saveContactUs } from "../../Services/otherServices";
import { useNavigate} from "react-router-dom";
import AlertContainer from "../../Components/AlertBoxes/alertBox";
import alertGreen from "../../Assets/Icons/alertGreen.svg";
import alertRed from "../../Assets/Icons/alertRed.svg";

const DetailFields = styled.div`
padding-bottom:45px;
    p{
        font-size:12px;
        line-height:20px;
        font-family:var(--sf-pro-text);
        color:var(--para-text);
        margin:0;
    }
    label{
        font-size:16px;
        line-height:20px;
        font-family:var(--sf-pro-display-m);
        color:var(--black-color);
        margin-bottom:5px;
        span{
            font-size:14px;
            font-style:italic;
            color:#8b8a88;
        }
    }
    .groupForm{
        border-bottom:1px solid #EDEBE9;
    }
    .groupDetailWrap{
        .ant-row{
            input[type="text"],input[type="password"]{
              padding-left:15px !important;
            }
            &.ant-form-item{
                margin-bottom:0px;
            }
        }
        .centerAlign{
            align-self:center;
            width:100%;
            border-bottom:1px solid #EDEBE9;
            padding:16px 0;
            > div{
                display:flex;
            }
            &:last-child{
                border-bottom:0px;
            }
        }
    }
    .boxFieldTitle{
        padding-left:25px;
    }
    .boxFormType{
        align-self:center;
        width:100%;
        .ant-select{
            width:100%;
        }
        &:last-child{
            margin-bottom:0px !important;
        }
    }
    .blockBreak{
        display:block !important;
        .d-flex{
            display:flex;
            max-width:100%;
            justify-content:space-between;
            > .boxFormType{
                flex:0 0 49%;
                max-width:49%;
                align-self:flex-start;
            }
        }
        .boxFormType{
            margin-bottom:18px;
        }
    }
    .m-width{
        max-width:100%;
    }
    .ant-row .ant-form-item-explain-error{
        min-height: 17px;
        position: absolute;
        bottom: -16px;
    }
`;

const { TextArea } = Input;

const Contact = (props) => {
    const history = useNavigate();
    const [form] = Form.useForm();
    const [actionResponse, setActionResponse] = useState({});
    const [toaster, setToaster] = useState(false);

    const showToaster = () => {
        setToaster(true);
        setTimeout(() => setToaster(false), 3000);
        setTimeout(() => history("/landing-page"), 3000);
    };

    const onSubmit = () => {
        let query = form.getFieldValue('Feedback');
        let body = {
            customer_account: CUSTOMER_ACCOUNT,
            query
        }
        saveContactUs(body).then((response) => {
            if(response){
             setActionResponse(response);
             showToaster();
            }
         }).catch((error) => {
             console.log(error.response.data);
             setActionResponse(error.response.data);
             setToaster(true);
             setTimeout(() => setToaster(false), 3000);
         });
    }

    const onCancel = () => {
        history("/landing-page");
    }

    return (
        <Layout>
            <HeaderNav />
            <RightLayoutContainer>
                <OtherPages>
                    <Layout
                        style={{
                            backgroundColor: "#ffffff",
                            paddingTop: "11px",
                        }}
                    >
                        <Row gutter={[16]} style={{ padding: "0 11%", justifyContent: "space-between" }}>
                            <Col span={5}>
                                <div className="pageLeftGutter">
                                    <PageMenuData />
                                </div>
                            </Col>
                            <Col span={18}>
                                <div className="pageRightGutter">
                                    <div className="pageContentWrap">
                                        <div class="form-wrap">
                                            <FeedbackBoard>
                                                <div className="topcontact">
                                                    <h1>Talk to a product support <br></br>expert</h1>
                                                    <p>Have questions about pricing, plans, or Deckle matching? Fill out the form and a product analytics<br></br> expert will be in touch shortly</p>
                                                </div>
                                                <DetailFields>
                                                    <HaberForm>
                                                        <div className="groupDetailWrap">
                                                            <Form form={form} name="basic" autoComplete="off" className="haberLogin">
                                                                <Row gutter={[16, 16]} className="groupForm" style={{borderBottom:"0"}}>
                                                                    <Col span={24}>
                                                                        <Row className="centerAlign">
                                                                            <Col span={12}>
                                                                                <div className="boxFieldTitle">
                                                                                    <label>Your email address</label>
                                                                                    <p>Specify your email address where we can contact you</p>
                                                                                </div>
                                                                            </Col>
                                                                            <Col span={12}>
                                                                                <div className="boxFormType">
                                                                                    <Form.Item name="Email Address"
                                                                                        rules={[{ required: true }]} className=""
                                                                                    >
                                                                                        <Input placeholder="Email address" />
                                                                                    </Form.Item>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row className="centerAlign">
                                                                            <Col span={12}>
                                                                                <div className="boxFieldTitle">
                                                                                    <label>Your message</label>
                                                                                    <p>Please briefly explain your Message</p>
                                                                                </div>
                                                                            </Col>
                                                                            <Col span={12}>
                                                                                <div className="boxFormType">
                                                                                <GlobalSet>
                                                                                    <Form.Item
                                                                                        name="Feedback"
                                                                                        rules={[{ required: true }]}
                                                                                        className=""
                                                                                    >
                                                                                        <TextArea
                                                                                        maxLength={100}
                                                                                        style={{ height: 90 }}
                                                                                        placeholder="Your Message"
                                                                                        />
                                                                                    </Form.Item>
                                                                                </GlobalSet>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                        <div className="accept-check">
                                                                        <Form.Item
                                                                        name="remember"
                                                                        valuePropName=""
                                                                        wrapperCol={{ span: 24 }}
                                                                        className="alignedBox"
                                                                        >
                                                                        <Checkbox className="logCheck">Haber can contact me regarding my concern</Checkbox>
                                                                        </Form.Item>
                                                                        </div>
                                                                        <div className="functional-btn">
                                                                        <Form.Item>
                                                                        <Button
                                                                            type="primary"
                                                                            className="themeBtn noBg"
                                                                            onClick={() => onCancel()}
                                                                        >
                                                                            Cancel
                                                                        </Button>
                                                                        </Form.Item>
                                                                        <Form.Item>
                                                                        <Button
                                                                            type="primary"
                                                                            htmlType="submit"
                                                                            className="themeBtn"
                                                                            onClick={() => onSubmit()}
                                                                        >
                                                                            Submit
                                                                        </Button>
                                                                        </Form.Item>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Form>
                                                        </div>
                                                    </HaberForm>
                                                </DetailFields>
                                                <div className="companyRights">
                                                    <div className="companycontact">
                                                        <div className="companyLogo">
                                                            <img src={logoCompany} alt="Haberwater"/>
                                                        </div>
                                                        <label>info@haberwater.com</label>
                                                        <label>(022)-4893-1836</label>
                                                        <ul>
                                                            <li><a href="https://twitter.com/HABER_TECH" target="_blank"><img src={twitter} alt="twitter"/></a></li>
                                                            <li><a href="https://www.linkedin.com/company/haber-tech/" target="_blank"><img src={linkedin} alt="linkedin"/></a></li>
                                                            <li><a href="https://www.haberwater.com/" target="_blank"><img src={website} alt="weblink"/></a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="companyAddress">
                                                        <h6>Office</h6>
                                                        <p>Haber (Elixa Technologies Pvt. Ltd.),<br></br> C-1001, Amar Business Zone,<br></br> Baner, Pune Maharashtra, 411 045</p>
                                                    </div>
                                                </div>
                                            </FeedbackBoard>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Layout>
                </OtherPages>
                {toaster && (
                        <AlertContainer
                        closeIcon={true}
                        setClose={setToaster}
                        color={`${actionResponse.error ? "red" : "green"} toaster`}
                        icon={actionResponse.error ? alertRed : alertGreen}
                        msg={actionResponse.msg}
                        />
                    )}
            </RightLayoutContainer>
        </Layout>
    );
};
export default Contact;
